/**
 * Labels of the check-inventory modal (`./CheckInventoryModal.tsx` and its table cells) in
 * en / fr / es. `itemNotAvailableLocallyMessage`, `chatWithUs`, `or` and `errorMessage2` are read
 * in that order as one sentence around the chat link and phone number. `iNeed` is read only by
 * the commented-out quantity input, which is dead code to be removed; `total`, `outOf` and
 * `addSelectedToCart` have no reader.
 */
import { LanguageContent } from "@ryerson/frontend.common";

/** Label keys of the check-inventory modal. */
export type CheckInventoryLabels = {
	batchLevelInfo: string;
	iNeed: string;
	batch: string;
	available: string;
	total: string;
	outOf: string;
	addSelectedToCart: string;
	back: string;
	itemNotAvailableLocallyMessage: string;
	chatWithUs: string;
	or: string;
	errorMessage2: string;
	loading: string;
	cancel: string;
};

/** Check-inventory labels by language. */
export const CheckInventoryContent: LanguageContent<CheckInventoryLabels> = {
	en: {
		batchLevelInfo: "Batch Level Information",
		iNeed: "I need",
		batch: "Batch",
		available: "Available (lbs)",
		total: "Total",
		outOf: "out of",
		addSelectedToCart: "Add Selected Items to Cart",
		back: "Back",
		itemNotAvailableLocallyMessage:
			"Good news! You can proceed with submitting your order. The item that you selected is not available locally, but we are happy to find what you need.",
		chatWithUs: "Chat with us",
		or: "or call",
		errorMessage2: "for further assistance.",
		loading: "Loading...",
		cancel: "Cancel",
	},
	fr: {
		batchLevelInfo: "Renseignements sur le niveau du lot",
		iNeed: "J’ai besoin",
		batch: "Lot",
		available: "disponible(s) (lbs)",
		total: "Total",
		outOf: "sur",
		addSelectedToCart: "Ajouter les articles sélectionnés au panier",
		back: "Retour ",
		itemNotAvailableLocallyMessage:
			"Bonne nouvelle! Vous pouvez maintenant soumettre votre commande. L’article que vous avez sélectionné n’est pas disponible localement, mais nous nous ferons un plaisir de trouver ce dont vous avez besoin.",
		chatWithUs: "Chattez avec nous",
		or: "ou appelez",
		errorMessage2: "pour obtenir assistance.",
		loading: "En cours de chargement…",
		cancel: "Annuler",
	},
	es: {
		batchLevelInfo: "Información del nivel de lote",
		iNeed: "Necesito",
		batch: "Lote",
		available: "disponible (lbs)",
		total: "Total",
		outOf: "de",
		addSelectedToCart: "Agregar artículos seleccionados al carrito",
		back: "Regresar",
		itemNotAvailableLocallyMessage:
			"¡Buenas noticias! Puede continuar con el envío de su pedido. El artículo seleccionado no está disponible localmente, pero estaremos encantados de encontrar lo que necesita.",
		chatWithUs: "Chatea con nosotros",
		or: "o",
		errorMessage2: "para obtener ayuda.",
		loading: "Cargando...",
		cancel: "Cancelar",
	},
};
